<div class="typing-container">
  <div class="typing-dot" [class.active]="activeIndex === 0">
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
      <circle cx="3" cy="3" r="3" />
    </svg>
  </div>
  <div class="typing-dot" [class.active]="activeIndex === 1">
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
      <circle cx="3" cy="3" r="3" />
    </svg>
  </div>
  <div class="typing-dot" [class.active]="activeIndex === 2">
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
      <circle cx="3" cy="3" r="3" />
    </svg>
  </div>
</div>
